<script lang="ts" context="module">
  import PageFooter from "./show_new/PageFooter.svelte";
  import { createShowContext } from "./show_new/showContext";
  import Toolbar from "./show_new/Toolbar.svelte";
  import { createSocialButtonContext } from "./show_author_new/socialContext";
import { onMount } from "svelte";
</script>

<script lang="ts">
  export let newsletterId: string;
  export let showPromotionBar: boolean;
  export let showFullBar: boolean;
  export let showMinimalBar: boolean;
  export let showSocialIcons: boolean;
  export let showAddReaction: boolean;
  export let showTranslations: boolean;
  export let showAccessibilityIcons: boolean;
  export let translateView: boolean;
  export let shortUrl: string;
  export let canonicalUrl: string;
  export let screenshotUrl: string;
  export let metaTitle: string;
  export let smoreBaseDomain: string;
  export let smoreImageUrl: string;
  export let itsAwesomeImageUrl: string;

  createShowContext({
    showPromotionBar,
    showFullBar,
    showMinimalBar,
    showSocialIcons,
    showAddReaction,
    showTranslations,
    showAccessibilityIcons,
    translateView,
    smoreImageUrl,
    itsAwesomeImageUrl
  });

  createSocialButtonContext({
    newsletterId,
    shortUrl,
    metaTitle,
    canonicalUrl,
    screenshotUrl,
    smoreBaseDomain
  });


  // Handle tracked url fixes
  function handleTrackedLinks(e: MouseEvent | TouchEvent){
    const t = e.target?.closest('a.skip-tracking[track-href]')    
    if(t){
      // @ts-ignore
      if(t.classList.contains("fancy-pic") && e.buttons === 1) {
        return
      }
      t.href = t.getAttribute('track-href') || t.href;
    }
  }
</script>

<svelte:body on:mousedown={handleTrackedLinks} on:touchstart={handleTrackedLinks} />

<Toolbar />
<PageFooter />
